<template>

    <div class="text-center" :key="id">
        <div class="p-card-title small p-mb-2 title" v-if="title">
            {{$t(title)}}
        </div>
        <ImageFromServer :src="srcImage" v-if="fromServer" class="img"/>
        <img v-else :src="srcImage" class="img"/>
        <AvatarCropper :labels="labels"
                       :cropperOptions="cropperOptions"
                       :uploadHandler="result"
                :trigger="'#'+id"/>
        <Button class="p-button p-component" icon="pi pi-plus" :label="$t('btn.choose')" type="file" ref="input" :id="id" accept="image/*" :maxFileSize="1000000" />
    </div>

</template>

<script>
    import AvatarCropper from "vue-avatar-cropper";
    import ImageFromServer from "@/components/image/ImageFromServer";

    export default {
        components: {ImageFromServer, AvatarCropper },
        name: "ImageUpload",

        props: {
            id: {type: String, default: 'pick-image'},
            labels: {
                default() {
                    return {
                        submit: this.$t('btn.choose'),
                        cancel: this.$t('btn.cancel')
                    }
                }
            },
            value: {type: String, default: null},
            imageFromServer: {type: Boolean, default: true},
            title: {type: String, default: null},
            cropperOptions: {type: Object, default() {
                    return {
                        aspectRatio: 1,
                        autoCropArea: 1,
                        viewMode: 1,
                        movable: false,
                        zoomable: false
                    }
                }
            }
        },

        data(){
            return {
                srcImage: null,
                fromServer: null,
                originalFile: null,
            }
        },

        mounted() {
            this.srcImage = this.value;
            this.fromServer = this.imageFromServer;
        },

        methods: {

            result(file){
                const type = file?.image?.currentSrc?.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
                let img = file.getCroppedCanvas({
                    minWidth: 256,
                    minHeight: 256,
                    maxWidth: 2096,
                    maxHeight: 2096,
                    fillColor: 'rgba(255,255,255,0)',
                    imageSmoothingEnabled: true,
                    imageSmoothingQuality: 'high',
                }).toDataURL(type);
                this.srcImage = img;
                this.fromServer = false;
                this.change();
            },

            change(){
                this.$emit('change', this.srcImage);
            }

        },

    }
</script>

<style scoped>

    .img {
        max-width: 300px;
        max-height: 300px;
    }

    .title {
        width: 300px;
        margin-left: auto;
        margin-right: auto;
        text-align: left;
    }


</style>
